import { render, staticRenderFns } from "./AssignToDepartment.vue?vue&type=template&id=9bb1aa64"
import script from "./AssignToDepartment.vue?vue&type=script&lang=js"
export * from "./AssignToDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports